import React from "react";
import SharedApplication from "../../App";
import { AppRuntimeProvider } from "../shared/AppRuntimeContext";
import { TIMELY_APP } from "./appDefinition";

export default function TimelyApp() {
  return (
    <AppRuntimeProvider app={TIMELY_APP}>
      <SharedApplication />
    </AppRuntimeProvider>
  );
}
